import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAuxiliaryGrid = (state, { auxGrid }) => {
  if (!auxGrid) return state;
  return state.merge({ auxGrid });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_AUXILIARY_GRID,
    actionFunction: setAuxiliaryGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
